import React from 'react';
import { Entity, LabelGraphics, ModelGraphics } from 'resium';
import * as Cesium from 'cesium';
import * as DOMPurify from 'dompurify';
import { Types } from '@wheeebo/polaris-api';
const WAYPOINT_MODEL_URI = '/map_pointer.glb';
const ICON_ALTITUDE_OFFSET = 2;
function WaypointEntity({ hideMarker, flightPath, waypoint, tracked }) {
    const color = tracked ? Cesium.Color.AQUA : Cesium.Color.CYAN;
    DOMPurify.setConfig({ ALLOWED_TAGS: [] });
    const description = [
        `<table><tr><td>Flight path</th><td>${DOMPurify.sanitize(flightPath.name)}</td></tr>`,
        `<tr><td>Action</th><td>${DOMPurify.sanitize(waypoint.action)}</td></tr>`,
    ];
    if (Types.isAltitudeRequired(waypoint.action)) {
        description.push(`<tr><td>Altitude</th><td>${waypoint.altitude || 0} m</td></tr>`);
    }
    if (Types.isYawRequired(waypoint.action)) {
        description.push(`<tr><td>Yaw</th><td>${waypoint.yaw || 0} \u00b0</td></tr>`);
    }
    if (Types.isDurationRequired(waypoint.action)) {
        description.push(`<tr><td>Duration</th><td>${waypoint.duration || 0} seconds</td></tr>`);
    }
    if (Types.isSpeedRequired(waypoint.action)) {
        description.push(`<tr><td>Speed</th><td>${waypoint.speed || 0} m/s</td></tr>`);
    }
    description.push('</table>');
    return (React.createElement(Entity, { position: Cesium.Cartesian3.fromDegrees(waypoint.location.lng, waypoint.location.lat, (waypoint.altitude || 0) + ICON_ALTITUDE_OFFSET), name: `Waypoint #${waypoint.sequenceNumber + 1}`, description: description.join('') },
        React.createElement(LabelGraphics, { text: `Waypoint #${waypoint.sequenceNumber + 1}`, scale: 0.8, showBackground: true, backgroundColor: color.withAlpha(0.5), backgroundPadding: new Cesium.Cartesian2(30, 10), eyeOffset: new Cesium.Cartesian3(0, 3, 0), horizontalOrigin: Cesium.HorizontalOrigin.CENTER, verticalOrigin: Cesium.VerticalOrigin.BOTTOM }),
        !hideMarker ? (React.createElement(ModelGraphics, { uri: WAYPOINT_MODEL_URI, runAnimations: true, scale: 1, maximumScale: 1.25, minimumPixelSize: 32 })) : null));
}
export default React.memo(WaypointEntity);
